import baseConfig, {
  baseBackgroundDark,
  baseBackgroundLight,
  baseTextDark,
  baseTextLight,
  baseTheme,
} from './defaultTheme';
import YSConfig, {
  YSBackgroundLight,
  YSTextDark,
  YSTextLight,
  YSTheme,
  YSThemeStyleRadius,
} from './YSTheme';

export const textLight = {
  ...baseTextLight,
  ...YSTextLight,
};

export const textDark = {
  ...baseTextDark,
  ...YSTextDark,
};

export const backgroundLight = {
  ...baseBackgroundLight,
  ...YSBackgroundLight,
};

export const backgroundDark = {
  ...baseBackgroundDark,
};

export const defaultTheme = {
  ...baseTheme,
  ...YSTheme,
};

/**
 * ARCHITECT'S NOTE:
 * We are using a deep merge approach.
 * YSConfig and YSTheme properties will overwrite baseConfig and baseTheme.
 */
const defaultConfig = {
  ...baseConfig,
  ...YSConfig,

  themeStyleRadius: YSThemeStyleRadius,

  theme: {
    ...baseTheme.theme,
    ...YSTheme.theme,

    cardRadius: YSThemeStyleRadius.STANDARD,

    palette: {
      ...baseTheme.theme.palette,
      ...YSTheme.theme.palette,

      primary: {
        ...baseTheme.theme.palette.primary,
        ...YSTheme.theme.palette.primary,
      },

      background: {
        ...baseTheme.theme.palette.background,
        ...YSTheme.theme.palette.background,
      },

      gray: {
        ...baseTheme.theme.palette.gray,
        ...YSTheme.theme.palette.gray,
      },
    },

    components: {
      ...baseTheme.theme.components,
      ...YSTheme.theme.components,
    },
  },
};

export default defaultConfig;
